import { useSelector } from 'react-redux';
import { selectSeoQuickLinksTabs } from 'shared/selectors/landing';
import { QuickLinksTabsComponent } from '../../components/QuickLinks';

export const QuickLinks = () => {
  const tabs = useSelector(selectSeoQuickLinksTabs);

  /* istanbul ignore next */
  if (tabs.length === 0) {
    return null;
  }

  return <QuickLinksTabsComponent tabs={tabs} />;
};
